import calmGradient from '@/../public/_n/images/calm-text-gradient.png';

import { Container } from './styles';

interface CalmGradientTextProps {
	text: string;
	className?: string;
}

const CalmGradientText = ({ text, className }: CalmGradientTextProps) => {
	return (
		<Container className={className}>
			<svg role="img" aria-label={text}>
				<defs>
					<pattern
						id="calm-text-gradient"
						data-testid="calm-text-gradient"
						patternUnits="userSpaceOnUse"
						width="2"
						height="2em"
					>
						<image xlinkHref={calmGradient.src} width="2" height="60" data-testid="gradient-image" />
					</pattern>
				</defs>
				<text textAnchor="middle" x="50%" y="50%" fill="url(#calm-text-gradient)">
					{text}
				</text>
			</svg>
		</Container>
	);
};

export default CalmGradientText;
